// extracted by mini-css-extract-plugin
export var downArrow = "_9o-0";
export var infoTooltipIcon = "_9o-3";
export var label = "_9o-1";
export var optionCard = "_9o-4";
export var upArrow = "_9o-2";